import classNames from "classnames/bind";
import styles from "./TableListConfig.module.css";
import { ColorPicker, Form, Input, Select, Switch, Table } from "antd";
import { forwardRef, useEffect, useState } from "react";
import { DownIcons } from "../../../components/Icons/Icons";
import FormItem from "antd/es/form/FormItem";
import { useForm } from "antd/es/form/Form";

const cx = classNames.bind(styles);


const TableListConfig = forwardRef(function TableListConfig({ name, dataSource = [], onChange, columns }, ref) {
    // truyền ref để submit từ bên ngoài
    const [tableCol, setTableCol] = useState([]);
    const [form] = useForm();

    // Xử lý thay đổi màu
    function onChangeColor(val, key, pst) {
        const fields = form?.getFieldsValue();
        const { configs } = fields;
        Object.assign(configs[pst], { [`${key}`]: val });
        form.setFieldsValue({ configs });
    }
    // xử lý cột của bảng được đưa vào form antd
    useEffect(() => {
        const listCol = columns?.map(item => {
            switch (item?.type) {
                case "input":
                    return {
                        ...item,
                        render: (col, row, index) =>
                            <FormItem
                                name={[index, item?.key]}
                                initialValue={col}
                            >
                                <Input {...item?.props} />
                            </FormItem>
                    }
                case "select":
                    return {
                        ...item,
                        render: (col, row, index) =>
                            <FormItem
                                name={[index, item?.key]}
                                noStyle
                                initialValue={col}
                            >
                                <Select
                                    className={cx("select")}
                                    placeholder={"Tất cả"}
                                    notFoundContent={<></>}
                                    suffixIcon={<DownIcons />}
                                    options={item?.options || []}
                                    {...item?.props}
                                />
                            </FormItem>
                    }
                case "switch":
                    return {
                        ...item,
                        render: (col, row, index) => (
                            <Form.Item name={[index, item?.key]}
                                noStyle
                                initialValue={col}
                            >
                                <Switch
                                    {...item?.props}
                                    className={cx("switch")}
                                />
                            </Form.Item>
                        )
                    }
                case "color-picker":
                    return {
                        ...item,
                        render: (col, row, index) =>
                            <FormItem
                                name={[index, item?.key]}
                                noStyle
                                initialValue={"#" + col}
                            >
                                <ColorPicker
                                    {...item?.props}
                                    className={cx('color-picker')}
                                    format={'hex'}
                                    mode={'single'}
                                    onChange={(e) => {
                                        onChangeColor(e.toHexString(), item?.key, index)
                                    }}
                                />
                            </FormItem>
                    }
                default:
                    return item;
            }
        })
        setTableCol(listCol)
    }, [columns])
    const handleSubmit = (infoConfig) => {
        onChange(infoConfig);
    }
    return (
        <div className={cx('wrapper-table')}>
            {/* <h2 className={cx('name-table')}>{name}</h2> */}
            {dataSource && dataSource?.length > 0 && (
                <Form onFinish={handleSubmit} initialValues={{
                    configs: [{}]
                }}
                    ref={ref}
                    form={form}
                >
                    <Form.List name={"configs"}>
                        {() => {
                            return (
                                <Table
                                    dataSource={dataSource}
                                    columns={tableCol}
                                    pagination={false}
                                    className={cx('table')}
                                    size="small"
                                    title={() => <h2 className={cx('name-table')}>{name}</h2>}
                                />
                            )
                        }}
                    </Form.List>
                </Form>)}
        </div >
    )
})

export default TableListConfig;